import { BaseModel } from '../core/abstractions/base.model';

export class PermissionModel extends BaseModel {
    name: string;
    description: string;
    isGranted?: boolean;
    groupTitle?: string;
}
